module.exports = __webpack_public_path__ + "static/media/landing_video.98a53017.mp4";